//https://stackoverflow.com/questions/1267283/how-can-i-pad-a-value-with-leading-zeros
export default function zeroFill(num: number, width: number) {
    const numStr = num + "";
    width -= num.toString().length;

    return (width > 0) ?
        new Array(width + (/\./.test(numStr) ? 2 : 1)).join('0') + num :
        numStr; // always return a string
}